/* Tres Vera — locale-selector toggle + URL-based locale switch. */
(function () {
  function closeAll() {
    document.querySelectorAll('.tv-locale__menu').forEach(function (m) { m.setAttribute('hidden', ''); });
    document.querySelectorAll('.tv-locale__trigger').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  }

  function localeCodes() {
    var first = document.querySelector('.tv-locale[data-tv-locale-codes]');
    if (!first) return [];
    return (first.getAttribute('data-tv-locale-codes') || '').split(',').filter(Boolean);
  }

  // Build the path under the target locale.
  // Shopify primary locale uses no prefix; secondary locales use /<code>/...
  function buildLocaleUrl(targetCode, isPrimary) {
    var codes = localeCodes();
    var path = window.location.pathname;
    var search = window.location.search;
    var hash = window.location.hash;

    // Strip any leading locale segment.
    var segs = path.split('/').filter(Boolean);
    if (segs.length > 0 && codes.indexOf(segs[0]) !== -1) {
      segs.shift();
    }
    var stripped = '/' + segs.join('/');
    if (stripped !== '/') stripped = stripped.replace(/\/$/, '');

    var newPath = isPrimary ? stripped : '/' + targetCode + stripped;
    if (newPath === '') newPath = '/';
    return newPath + search + hash;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.tv-locale__trigger');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var wrap = trigger.closest('.tv-locale');
      var menu = wrap && wrap.querySelector('.tv-locale__menu');
      if (!menu) return;
      var wasHidden = menu.hasAttribute('hidden');
      closeAll();
      if (wasHidden) {
        menu.removeAttribute('hidden');
        trigger.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    var option = e.target.closest('[data-tv-locale-value]');
    if (option) {
      e.preventDefault();
      var code = option.getAttribute('data-tv-locale-value');
      var isPrimary = option.getAttribute('data-tv-locale-primary') === 'true';
      window.location.assign(buildLocaleUrl(code, isPrimary));
      return;
    }

    if (!e.target.closest('.tv-locale')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();
